import { z } from "zod";
import { IsoTimestamp } from "./ids.js";

// Remote config + flags: one `config` table, realtime subscription, <2s propagation.
// Kill switches are just flags with the `kill.` prefix — the DUGOUT drawer lists these.
export const FlagKey = z.enum([
  "kill.match_create",
  "kill.match_join",
  "kill.result_submit",
  "kill.vault_claims",
  "kill.store",
  "kill.chat",
  "kill.push",
  "kill.moments_drops",
  "kill.find_match", // WHISTLE CHECK §4 — pauses new subscriptions server-side
  "feature.store",
  "feature.moments",
  "feature.silverware_hall",
  "feature.kitman",
  // Loop 3: the airtime/voucher payout rail — OFF until 20/20 staged fulfilments
  // pass (SEASON ONE gate). MOMENTS coin outcomes ship without it; a voucher
  // roll re-weights to coins while this is off (a promised-and-failed airtime
  // grant is the one unaffordable reward failure).
  "feature.voucher_rail",
  // Loop 4B: token-entry tournaments — OFF until the entry-token ledger exists (DRIFT-009).
  "feature.entry_tokens",
  // Loop 5 (THE VOICE): channel infrastructure toggles.
  "feature.web_push", // web-push (VAPID) notification channel
  "feature.sms_notifications", // SMS notification channel — cost-gated, OFF by default
  "juice.tier_override", // '' | 'FULL' | 'TRIM' | 'LITE' — PACER escape hatch, BK-logged use only
]);
export type FlagKey = z.infer<typeof FlagKey>;

export const ConfigRow = z.object({
  key: z.string().min(1),
  value: z.unknown(), // jsonb; flag rows are boolean/string, night config etc. structured
  version: z.number().int().min(1),
  updated_at: IsoTimestamp,
  updated_by: z.string().min(1), // audit line — DUGOUT service role writes only
});
export type ConfigRow = z.infer<typeof ConfigRow>;

export const FlagState = z.object({
  key: FlagKey,
  enabled: z.boolean(),
  note: z.string().nullable(),
  version: z.number().int().min(1),
  updated_at: IsoTimestamp,
  updated_by: z.string().min(1),
});
export type FlagState = z.infer<typeof FlagState>;
